"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleHeader = void 0;
var tslib_1 = require("tslib");
var dayjs_1 = tslib_1.__importDefault(require("dayjs"));
var utc_1 = tslib_1.__importDefault(require("dayjs/plugin/utc"));
var timezone_1 = tslib_1.__importDefault(require("dayjs/plugin/timezone"));
var customParseFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/customParseFormat"));
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var React = tslib_1.__importStar(require("react"));
var ReactCanWrapper_1 = require("../../../ReactCanWrapper");
var LeftRailHeader_1 = require("../LeftRailHeader/LeftRailHeader");
require("./styles.less");
var initialDateFormat = 'YYYY-MM-DDTHH:mm:ssZ';
var convertedDateFormat = 'MMMM DD, YYYY';
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
function renderDate(date) {
    return dayjs_1.default(date, initialDateFormat).format(convertedDateFormat);
}
function ArticleHeader(props) {
    return (React.createElement("section", { className: 'm-article-header' },
        React.createElement(LeftRailHeader_1.LeftRailHeader, { homepageUrl: props.homepageUrl, date: props.issuesDate, issues: props.issues, subscribeLink: props.subscribeLink }),
        React.createElement("span", { className: 'm-article-header__section-tag' }, props.sectionTag),
        React.createElement(ReactCanWrapper_1.ReactCanWrapper, { template: "<h1 class='m-article-header__title'>" + (lodash_1.default.isEmpty(props.richTitle) ? props.title : props.richTitle) + "</h1>" }),
        React.createElement("h3", { className: 'm-article-header__sub-title' }, props.subTitle),
        React.createElement("div", { className: 'm-article-header__column' },
            React.createElement("div", { className: 'm-article-header__caption m-article-header__caption--date' }, renderDate(props.date)),
            renderAuthors(props.authors))));
}
exports.ArticleHeader = ArticleHeader;
function renderAuthors(authors) {
    if (authors && authors.length) {
        return authors.map(function (element, index) { return (React.createElement("span", { className: 'm-article-header__caption m-article-header__caption--author', key: index },
            element.name,
            element.title ? ", " + element.title : '')); });
    }
}
